import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Whether the "Save to project" feature is available to the current user.
 *
 * Centralizing the check keeps every "Save to project" entry point
 * (Opportunities, Focus Groups, …) consistent.
 */
export function useSaveToProjectEnabled(): boolean {
  const projectsModuleEnabled = useBooleanFlagValue('projects_module', false);
  return projectsModuleEnabled;
}
